import { render, staticRenderFns } from "./TruckDetail.vue?vue&type=template&id=aaa74cb2&scoped=true"
import script from "./TruckDetail.vue?vue&type=script&lang=js"
export * from "./TruckDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa74cb2",
  null
  
)

export default component.exports